  import { motion } from "framer-motion";
import colors from "../../styles/colors";
import Button from "../Button";
import { useTranslation } from "react-i18next";

const PortfolioSection = () => {
  const { t } = useTranslation();

  return (
    <section
      className="w-full flex flex-col min-h-[30vh] md:flex-row items-center px-8 lg:px-20 py-16"
      style={{
        backgroundColor: colors.pastelCream,
      }}
    >
      <div className="w-full md:w-1/2 space-y-8 p-2">
        <motion.h2
          className="text-4xl md:text-7xl font-serif"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: false, amount: 0.5 }}
          style={{ color: colors.darkBrown }}
        >
          {t("portfolioSection.title")}
        </motion.h2>
        <motion.p
          className="lg:text-2xl text-lg md:text-xl font-serif"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true, amount: 0.5 }}
          style={{ color: colors.darkBrown }}
        >
          {t("portfolioSection.text")}
        </motion.p>
        <Button to={"/portfolio"} text={t("portfolioSection.button")} />
      </div>

      {/* Grid Layout */}
      <div className="w-full md:w-1/2 grid grid-cols-3 gap-2 mt-8 md:mt-0">
        {/* 1. Oszlop (1 kép) */}
        <motion.div
          className="col-span-1"
          initial="hidden"
          whileInView="visible"
        >
          <motion.img
            src="/assets/images/portfolio/caritas_project.webp"
            alt={t("image_alt.portfolio_sec.caritas")}
            loading="lazy"
            className="w-full h-auto rounded-md shadow-xl"
            initial={{ opacity: 0 }}
            whileInView={{
              opacity: 1,
              transition: { delay: 0.8, duration: 1 },
            }}
            viewport={{ once: false, amount: 0.5 }}
          />
        </motion.div>

        {/* 2. Oszlop (2 kisebb kép) */}
        <div className="col-span-1 grid grid-rows-2 gap-2">
          <motion.img
            src="/assets/images/portfolio/branzan_project.webp"
            alt={t("image_alt.portfolio_sec.branzan")}
            loading="lazy"
            className="w-full h-auto rounded-md shadow-lg"
            initial={{ opacity: 0 }}
            whileInView={{
              opacity: 1,
              transition: { delay: 0.6, duration: 1 },
            }}
            viewport={{ once: false, amount: 0.5 }}
          />
          <motion.img
            src="/assets/images/portfolio/hintz_project.webp"
            alt={t("image_alt.portfolio_sec.hintz")}
            loading="lazy"
            className="w-full h-auto rounded-md shadow-xl"
            initial={{ opacity: 0 }}
            whileInView={{
              opacity: 1,
              transition: { delay: 0.4, duration: 1 },
            }}
            viewport={{ once: false, amount: 0.5 }}
          />
        </div>

        {/* 3. Oszlop (1 nagyobb kép) */}
        <motion.div
          className="col-span-1"
          initial="hidden"
          whileInView="visible"
        >
          <motion.img
            src="/assets/images/portfolio/tektum_project.webp"
            className="w-full h-full object-cover rounded-md shadow-xl"
            alt={t("image_alt.portfolio_sec.tektum")}
            loading="lazy"
            initial={{ opacity: 0 }}
            whileInView={{
              opacity: 1,
              transition: { delay: 0.2, duration: 1 },
            }}
            viewport={{ once: false, amount: 0.5 }}
          />
        </motion.div>
      </div>
    </section>
  );
};

export default PortfolioSection;
